<script setup>
import { Assets } from '@/plugins/obscore.js'

const props = defineProps({
  type: String,
  title: String,
  image: String,
  imageExpanded: String,
  avatar: Object,
  expanded: { default: false },
});

const image = Assets(`./${props.image}`)
const imageExpanded = props.imageExpanded ? Assets(`./${props.imageExpanded}`) : null

var avatar = false;
var text = false;
switch (props.type) {
  case "image":
    avatar = true;
    text = false;
    break;
  case "text":
    avatar = false;
    text = true;
    break;
  case "both":
    avatar = true;
    text = true;
    break;
}
</script>

<template>
  <v-list-item class="pa-0 mb-n1">
    <v-img
      v-if="avatar && props.expanded && props.imageExpanded"
      v-bind="props.avatar"
      :src="imageExpanded"
    />
    <v-list-item-avatar
      v-else
      v-bind="props.avatar"
      :image="avatar ? image : null"
    >
      <span v-if="!avatar" class="text-h5">{{
        props.title ? props.title[0] : ""
      }}</span>
    </v-list-item-avatar>
    <slot name="default">
      <v-list-item-title
        v-if="text"
        class="text-h5"
        style="line-height: 2rem"
        v-text="props.title"
      ></v-list-item-title>
    </slot>
  </v-list-item>
</template>